import { fromJS } from 'immutable'
import {
  UPDATE_IS_INTERNAL_USER,
  IS_INTERNAL_USER_END_FETCHING,
  IS_INTERNAL_USER_START_FETCHING,
} from '../actionTypes/index'

const initialState: any = fromJS({
  isInternalUser: false,
  isInternalUserFetchState: 'init',
})

const reducer = (state = initialState, action: { type: string; isInternalUser: boolean }) => {
  const { type, isInternalUser } = action
  switch (type) {
    case UPDATE_IS_INTERNAL_USER: {
      return state.set('isInternalUser', isInternalUser)
    }
    case IS_INTERNAL_USER_START_FETCHING: {
      return state.set('isInternalUserFetchState', 'fetching')
    }
    case IS_INTERNAL_USER_END_FETCHING: {
      return state.set('isInternalUserFetchState', 'fetched')
    }
    default:
      return state
  }
}

export default reducer
